import styled, { css } from 'styled-components'

import { colors } from '../../../../styles/colors'

interface IStyledItemProps {
  disabled?: boolean
  active?: boolean
}

export const StyledItem = styled.div<IStyledItemProps>`
  display: block;
  color: ${colors.grayLight};
  cursor: pointer;

  padding: 10px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;

  color: ${colors.white};
  background: ${colors.grayLight};

  font-family: Roboto, sans-serif;
  font-weight: 700;
  font-size: 14px;
  min-width: 116.99px;

  ${props =>
    props.active &&
    css`
      color: ${colors.white};
      background: ${colors.blue};
    `};
`

export const StyledItemContent = styled.div<IStyledItemProps>`
  font-weight: 600;
  padding-bottom: 6px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  ${props =>
    props.disabled &&
    css`
      cursor: none;
    `};
`
